import React from 'react';
import {
  Container, Title, PointsBlock, Wrapper,
} from './styles';
import { useSelector } from 'react-redux';
import { selectRewardsBalance } from 'store/rewards/selectors';
import { useIntl } from 'react-intl';
import { EMPTY_BALANCE } from 'shared/consts';

interface RewardsbalanceProps {
  rewardsBalanceRef: React.RefObject<HTMLDivElement>;
}

export const RewardsBalance = ({ rewardsBalanceRef }: RewardsbalanceProps): JSX.Element => {
  const intl = useIntl();
  const rewardsBalance = useSelector(selectRewardsBalance);
  const { balance } = rewardsBalance || {};
  // A NUMBER, not a pre-formatted string: the `points` message pluralizes on it (`1 Point` / `2 Points`) and
  // `#` formats it in the user's locale (`1,234` en, `1.234` de, `1 234` fr). `toLocaleString('en-US')` here
  // gave every locale US grouping, and a string like `"1,234"` is not a number to a plural selector.
  const points = balance ?? EMPTY_BALANCE;

  return (
    <Wrapper ref={rewardsBalanceRef}>
      <Container data-testid="rewards-balance-container">
        <Title>{intl.formatMessage({ id: 'pointsBalance' })}</Title>
        <PointsBlock>{intl.formatMessage({ id: 'points' }, { count: points })}</PointsBlock>
      </Container>
    </Wrapper>
  );
};
